<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epig"> </p>
<p class="EP">In any retreat, the wounded are left behind. Their suffering is the price of victory.</p>
<p class="EPC">—Queen Isabella of Castile</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?3c9e3c2b